let id = 1;
const randomId = () => {
	id++;
	return id;
};

export const navbarItems = [
	{
		id: randomId(),
		link: "/",
		icon: "fas fa-home",
		title: "لوحة التحكم",
		permissions: ["*"],
		children: [],
	},
	{
		id: randomId(),
		link: "/hero",
		icon: "fas fa-image",
		title: "مقدمة الموقع",
		permissions: ["*"],
		children: [],
	},
	{
		id: randomId(),
		link: "/moderators/index",
		icon: "fas fa-user",
		title: "المشرفين",
		permissions: ["admin-list", "admin-create", "admin-edit", "admin-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع المشرفين",
				link: "/moderators/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة مشرف جديد",
				link: "/moderators/create",
				permissions: ["admin-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/roles/index",
		icon: "fas fa-crown",
		title: "الصلاحيات",
		permissions: ["role-list", "role-create", "role-edit", "role-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الصلاحيات",
				link: "/roles/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة صلاحية جديدة",
				link: "/roles/create",
				permissions: ["role-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/blog/index",
		icon: "fas fa-edit",
		title: "المدونة",
		permissions: ["blog-list", "blog-create", "blog-edit", "blog-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع المقالات",
				link: "/blog/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة مقال جديد",
				link: "/blog/create",
				permissions: ["blog-create"],
			},
			{
				id: randomId(),
				title: "التصنيفات",
				link: "/categories/index",
				permissions: ["*"],
			},
		],
	},
	{
		id: randomId(),
		link: "/works/index",
		icon: "fas fa-images",
		title: "أعمالنا",
		permissions: ["post-list", "post-create", "post-edit", "post-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الأعمال",
				link: "/works/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة عمل جديد",
				link: "/works/create",
				permissions: ["post-create"],
			},
			{
				id: randomId(),
				title: "التصنيفات",
				link: "/sections/index",
				permissions: ["*"],
			},
		],
	},
	{
		id: randomId(),
		link: "/pages/index",
		icon: "fas fa-file",
		title: "الصفحات",
		permissions: ["page-list", "page-create", "page-edit", "page-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الصفحات",
				link: "/pages/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة صفحة جديدة",
				link: "/pages/create",
				permissions: ["page-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/services/index",
		icon: "fas fa-layer-group",
		title: "الخدمات",
		permissions: [
			"post-list",
			"post-create",
			"post-edit",
			"post-delete",
			"service-order-list",
			"service-order-edit",
			"service-order-delete",
		],
		children: [
			{
				id: randomId(),
				title: "جميع الخدمات",
				link: "/services/index",
				permissions: [
					"post-list",
					"post-create",
					"post-edit",
					"post-delete",
					"service-order-list",
					"service-order-edit",
					"service-order-delete",
				],
			},
			{
				id: randomId(),
				title: "اضافة خدمة جديدة",
				link: "/services/create",
				permissions: ["post-create"],
			},
			{
				id: randomId(),
				title: "طلبات الخدمات",
				link: "/services/applications",
				permissions: [
					"service-order-list",
					"service-order-edit",
					"service-order-delete",
				],
			},
			{
				id: randomId(),
				title: "تكاليف الخدمات",
				link: "/coasts/index",
				permissions: ["*"],
			},
		],
	},
	{
		id: randomId(),
		link: "/faq/index",
		icon: "fas fa-question",
		title: "الأسئلة الشائعة",
		permissions: ["post-list", "post-create", "post-edit", "post-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الأسئلة",
				link: "/faq/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة سؤال جديد",
				link: "/faq/create",
				permissions: ["post-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/employees/index",
		icon: "fas fa-users",
		title: "الموظفين",
		permissions: ["post-list", "post-create", "post-edit", "post-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الموظفين",
				link: "/employees/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة موظف جديد",
				link: "/employees/create",
				permissions: ["post-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/packages/index",
		icon: "fas fa-sitemap",
		title: "الباقات",
		permissions: ["post-list", "post-create", "post-edit", "post-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الباقات",
				link: "/packages/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة باقة جديدة",
				link: "/packages/create",
				permissions: ["post-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/partners/index",
		icon: "fas fa-handshake",
		title: "الشركاء",
		permissions: ["post-list", "post-create", "post-edit", "post-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الشركاء",
				link: "/partners/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة شريك جديدة",
				link: "/partners/create",
				permissions: ["post-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/opinions/index",
		icon: "fas fa-comment",
		title: "اراء العملاء",
		permissions: ["post-list", "post-create", "post-edit", "post-delete"],
		children: [
			{
				id: randomId(),
				title: "جميع الاراء",
				link: "/opinions/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "اضافة رأي جديد",
				link: "/opinions/create",
				permissions: ["post-create"],
			},
		],
	},
	{
		id: randomId(),
		link: "/",
		icon: "fas fa-hands-helping",
		title: "التوظيف",
		permissions: [
			"position-list",
			"position-create",
			"position-edit",
			"position-delete",
			"post-list",
			"post-create",
			"post-edit",
			"post-delete",
		],
		children: [
			{
				id: randomId(),
				title: "اسباب العمل لدينا",
				link: "/reasons/index",
				permissions: ["post-list", "post-create", "post-edit", "post-delete"],
			},
			{
				id: randomId(),
				title: "الوظائف",
				link: "/positions/index",
				permissions: [
					"position-list",
					"position-create",
					"position-edit",
					"position-delete",
				],
			},
			{
				id: randomId(),
				title: "طلبات التوظيف",
				link: "/careers/applications",
				permissions: [
					"position-list",
					"position-create",
					"position-edit",
					"position-delete",
				],
			},
		],
	},
	{
		id: randomId(),
		link: "/about/show",
		icon: "fas fa-id-card",
		title: "من نحن",
		permissions: ["*"],
		children: [],
	},
	{
		id: randomId(),
		link: "/contact/index",
		icon: "fas fa-envelope",
		title: "اتصل بنا",
		permissions: ["contact-list", "contact-edit", "contact-delete"],
		children: [],
	},
	{
		id: randomId(),
		link: "/subscribers",
		icon: "fas fa-bullhorn",
		title: "القائمة البريدية",
		permissions: ["subscribe-list", "subscribe-edit", "subscribe-delete"],
		children: [],
	},
	// {
	// 	id: 17,
	// 	link: "/offers",
	// 	icon: "fas fa-phone",
	// 	title: "ارقام العروض",
	// 	permissions: ["*"],
	// 	children: [],
	// },
	// {
	// 	id: 44,
	// 	link: "/intro/index",
	// 	icon: "fas fa-mobile",
	// 	title: "مقدمة التطبيق",
	// 	permissions: ["post-list", "post-create", "post-edit", "post-delete"],
	// 	children: [
	// 		{
	// 			id: 45,
	// 			title: "جميع المقدمات",
	// 			link: "/intro/index",
	// 			permissions: ["*"],
	// 		},
	// 		{
	// 			id: 46,
	// 			title: "اضافة مقدمة جديدة",
	// 			link: "/intro/create",
	// 			permissions: ["post-create"],
	// 		},
	// 	],
	// },
	// {
	// 	id: 75,
	// 	link: "/mail/index",
	// 	icon: "fas fa-download",
	// 	title: "طلبات الرسائل",
	// 	permissions: ["*"],
	// 	children: [],
	// },
	{
		id: randomId(),
		link: "/seo/index",
		icon: "fas fa-link",
		title: "سيو الصفحات",
		permissions: ["*"],
		children: [
			{
				id: randomId(),
				title: "قائمة السيو",
				link: "/seo/index",
				permissions: ["*"],
			},
			{
				id: randomId(),
				title: "إضافة سيو جديد",
				link: "/seo/create",
				permissions: ["*"],
			},
		],
	},

	{
		id: randomId(),
		link: "/seoRedirects",
		icon: "fas fa-download",
		title: "لينكات اعادة التوجيه",
		permissions: ["*"],
		children: [],
	},
];
